import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { DEFAULT_LOCALE, DEFAULT_LANG } from '@/constants';

import availableLocales from './available_locales';
import { retrieveLocale } from './utils';

// Locales
import enMessages from './translations/en';
// import enUSMessages from './translations/en_US';

Vue.use(VueI18n);

const locale = retrieveLocale() || DEFAULT_LOCALE;
const fallbackLocale = availableLocales[locale].fallbackLocale || DEFAULT_LANG;

Vue.config.lang = locale;

const i18n = new VueI18n({
  locale,
  fallbackLocale,
  silentTranslationWarn: true,
  messages: {
    en: enMessages,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js